export enum LogoSizeEnum {
    SM = "sm",
    MD = "md",
    LG = "lg",
}
